import { useState } from "react";
import AccountRDOHeader from "./components/AccountRDOHeader";
import AccountRDOTable from "./components/AccountRDOTable";

const AccountRDOs = () => {
  const [data, setData] = useState([]);

  const [tableOptions, setTableOptions] = useState({
    status: "",
    rdo: "",
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const columns = [
    { path: "name", label: "Name" },
    { path: "account_status_type", label: "Status" },
    { path: "number", label: "TIN" },
    { path: "rdo", label: "RDO" },
    { path: "created_on", label: "Date Registered" },
  ];

  return (
    <div className="px-6 lg:px-0">
      <div className="card">
        <AccountRDOHeader options={tableOptions} onChange={setTableOptions} />
        <AccountRDOTable
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default AccountRDOs;
